/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Legajox_Vacations_SuccessInputs */

const es_tools_legajox_vacations_success = /** @type {(inputs: Tools_Legajox_Vacations_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vacaciones de Legajox consultadas`)
};

const en_tools_legajox_vacations_success = /** @type {(inputs: Tools_Legajox_Vacations_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legajox vacations queried`)
};

/**
* | output |
* | --- |
* | "Legajox vacations queried" |
*
* @param {Tools_Legajox_Vacations_SuccessInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_legajox_vacations_success = /** @type {((inputs?: Tools_Legajox_Vacations_SuccessInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Legajox_Vacations_SuccessInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_legajox_vacations_success(inputs)
	return en_tools_legajox_vacations_success(inputs)
});
export { tools_legajox_vacations_success as "tools.legajox.vacations_success" }